"use client";

import { useId } from "react";
import { SegmentedControl } from "@/components/ui/segmented-control";

export type FulfillmentType = "delivery" | "pickup";

export interface PickupLocality {
  city: string;
  state: string;
  postalCode: string;
}

const PICKUP_UNAVAILABLE_MESSAGE =
  "Pickup is unavailable for this listing.";

export function formatPickupLocality(locality: PickupLocality) {
  return `${locality.city}, ${locality.state} ${locality.postalCode}`;
}

export function ListingQuoteFulfillmentField({
  value,
  onChange,
  pickupLocality,
  error,
}: {
  value: FulfillmentType;
  onChange: (next: FulfillmentType) => void;
  pickupLocality: PickupLocality | null;
  error?: string;
}) {
  const pickupAvailable = pickupLocality !== null;
  const pickupNoteId = useId();
  const errorId = useId();
  return (
    <div>
      <SegmentedControl
        fullWidth
        aria-label="Fulfillment method"
        aria-describedby={error ? `${pickupNoteId} ${errorId}` : pickupNoteId}
        value={value}
        onValueChange={onChange}
        options={[
          { value: "delivery", label: "Delivery" },
          {
            value: "pickup",
            label: "Pickup",
            disabled: !pickupAvailable,
            title: pickupAvailable ? undefined : PICKUP_UNAVAILABLE_MESSAGE,
          },
        ]}
      />
      <p id={pickupNoteId} className="mt-1.5 text-xs text-muted-foreground">
        {pickupLocality === null
          ? PICKUP_UNAVAILABLE_MESSAGE
          : value === "pickup"
            ? `Pickup from ${formatPickupLocality(pickupLocality)}.`
            : `Pickup available from ${formatPickupLocality(pickupLocality)}.`}
      </p>
      {error ? (
        <p id={errorId} className="mt-1 text-xs text-destructive-strong">
          {error}
        </p>
      ) : null}
    </div>
  );
}
